(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-date"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-date')) {
    customElements.define(
      'delivery-date',
      class extends HTMLElement {
        /* In stock at its own size: next working day. In stock, other size: resized,
           a few days. Otherwise made to order. Days are working days after the
           order is picked up, which is today if before the cutoff in London.
           Returns the date text. */
        render(variant, size, leadDays) {
          var d = this.dataset;
          var hol = {};
          (d.holidays.match(/\d{4}-\d{2}-\d{2}/g) || []).forEach(function (x) {
            hol[x] = 1;
          });
          var days = variant.stock ? (!size || size === variant.stockSize ? +d.stockDays : +d.otherDays) : +d.mtoDays;
          days += leadDays || 0;
          /* London time, not the browser's, so the cutoff is the same for everyone. */
          var p = {};
          new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/London',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: 'h23',
          })
            .formatToParts(new Date())
            .forEach(function (x) {
              p[x.type] = +x.value;
            });
          var day = new Date(Date.UTC(p.year, p.month - 1, p.day));
          var work = function (t) {
            var w = t.getUTCDay();
            return w > 0 && w < 6 && !hol[t.toISOString().slice(0, 10)];
          };
          var next = function (t) {
            do t.setUTCDate(t.getUTCDate() + 1);
            while (!work(t));
          };
          var left = d.cutoff * 60 - (p.hour * 60 + p.minute);
          var beforeCut = work(day) && left > 0;
          if (!beforeCut) next(day);
          for (var i = 0; i < days; i++) next(day);
          var date = day.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
          var tpl = !variant.stock ? d.tMto : beforeCut ? d.tStock : d.tStockLater;
          var countdown = (left >= 60 ? Math.floor(left / 60) + 'h ' : '') + (left % 60) + 'm';
          this.querySelector('[data-text]').innerHTML = tpl
            .replace('{date}', date)
            .replace('{countdown}', countdown);
          var note = this.querySelector('[data-note]');
          if (note) note.hidden = variant.stock;
          this.querySelector('input').value = date;
          this.hidden = false;
          return date;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
